<template>
  <div class="wrap">
    <div class="left">
      <div class="tree-wrap">
        <a-input-search
          placeholder="请搜索部门名称"
          enter-button
          @search="onSearchTree"
          style="margin-bottom: 20px"
        />
        <!-- <a-empty v-if="treeData.length === 0" /> -->
        <a-tree class="tree" :tree-data="treeData" @select="onSelect">
          <template slot="title" slot-scope="{ title, key }">
            <div class="icon-title">
              <div class="title">{{ title }}</div>
              <i
                v-if="selectedKeys && selectedKeys[0] === key"
                class="iconfont icon-dian"
              />
            </div>
          </template>
        </a-tree>
      </div>
      <div class="add-wrap" v-if="currentDepartment.level !== 3">
        <a-button style="width: 100%" @click="add">{{
          selectedKeys[0] === 0 || selectedKeys.length === 0
            ? "添加部门"
            : "添加子部门"
        }}</a-button>
      </div>
    </div>
    <div class="right">
      <div class="header-wrap" v-if="selectedKeys">
        <div class="header">
          <div class="line-title">
            <div class="line"></div>
            <div class="title" v-if="selectedKeys[0] === 0">企业信息</div>
            <div class="title" v-else>部门信息</div>
          </div>
          <div class="btn-wrap">
            <a-button
              style="margin-right: 24px"
              @click="edit({ department: '产品部', remark: '产品经理' })"
              >修改</a-button
            >
            <a-button
              v-if="selectedKeys[0] !== 0"
              class="delete"
              style="margin-right: 24px"
              @click="showDeleteModal({ type: 'remove' })"
              >删除</a-button
            >
          </div>
        </div>
        <div class="info" v-if="selectedKeys[0] === 0">
          <a-row :gutter="16">
            <a-col :span="8">
              <div class="info-item">
                <i class="iconfont icon-jianzhuguanli" />
                <div class="value">企业名称：</div>
                <a-tooltip :title="enterprise.enterpriseName">
                  <div class="label">
                    {{ enterprise.enterpriseName || "--" }}
                  </div>
                </a-tooltip>
              </div>
            </a-col>
            <a-col :span="8">
              <div class="info-item">
                <i class="iconfont icon-shijian" />
                <div class="value">修改时间：</div>
                <a-tooltip :title="enterprise.lastUpdated">
                  <div class="label">{{ enterprise.lastUpdated || "--" }}</div>
                </a-tooltip>
              </div>
            </a-col>
            <a-col :span="8">
              <div class="info-item">
                <i class="iconfont icon-beizhu" />
                <div class="value">备注：</div>
                <a-tooltip :title="enterprise.remark">
                  <div class="label">{{ enterprise.remark || "--" }}</div>
                </a-tooltip>
              </div>
            </a-col>
          </a-row>
        </div>
        <div class="info" v-else>
          <a-row :gutter="16">
            <a-col :span="6" v-if="currentDepartment.parentId">
              <div class="info-item">
                <i class="iconfont icon-jianzhuguanli" />
                <div class="value">上级部门：</div>
                <a-tooltip :title="currentDepartment.parentName">
                  <div class="label">
                    {{ currentDepartment.parentName || "--" }}
                  </div>
                </a-tooltip>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <i class="iconfont icon-jiaoseleixing" />
                <div class="value">部门名称：</div>
                <a-tooltip :title="currentDepartment.departmentName">
                  <div class="label">
                    {{ currentDepartment.departmentName || "--" }}
                  </div>
                </a-tooltip>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <i class="iconfont icon-shijian" />
                <div class="value">修改时间：</div>
                <a-tooltip :title="currentDepartment.lastUpdated">
                  <div class="label">
                    {{ currentDepartment.lastUpdated || "--" }}
                  </div>
                </a-tooltip>
              </div>
            </a-col>
            <a-col :span="6">
              <div class="info-item">
                <i class="iconfont icon-beizhu" />
                <div class="value">备注：</div>
                <a-tooltip :title="currentDepartment.remark">
                  <div class="label">
                    {{ currentDepartment.remark || "--" }}
                  </div>
                </a-tooltip>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="table-wrap" v-if="selectedKeys">
        <div class="table-title">
          <div class="line-title">
            <div class="line"></div>
            <div class="title" v-if="selectedKeys[0] === 0">
              关联用户列表 （关联人数：{{ dataSource.length }}人)
            </div>
            <div class="title" v-else>
              企业用户列表 （总人数：{{ dataSource.length }}人)
            </div>
          </div>
          <div class="btn-wrap">
            <a-button
              v-if="selectedKeys[0] !== 0"
              @click="openStaffAssignments(currentDepartment)"
              >人员分配</a-button
            >
          </div>
        </div>
        <div class="table" id="tables">
          <a-table
            :columns="getColumns"
            :data-source="dataSource"
            :pagination="{ ...pagination, showSizeChanger: false }"
            @change="(pagination) => getDataList(pagination.current - 1)"
          >
            <template slot="operation" slot-scope="record">
              <!-- <a-popconfirm
                  title="确定移出部门？"
                  @confirm="() => removeOut(record)"
                >
                  <div style="color: #1e96ff; cursor: pointer">移出部门</div>
                </a-popconfirm>
              </div> -->
              <div class="handle">
                <a-tooltip title="移出部门">
                  <div
                    class="icon"
                    @click="
                      showDeleteModal({ type: 'removeOut', record: record })
                    "
                  >
                    <i class="iconfont icon-yichu" />
                  </div>
                </a-tooltip>
              </div>
            </template>
          </a-table>
        </div>
      </div>
      <div class="no-empty" v-if="!selectedKeys">
        <a-empty
          class="empty-wrap"
          :imageStyle="{ width: '648px', height: '324px' }"
          description="暂无数据，请选择部门"
        >
          <template slot="image">
            <img src="../../../assets/noempty/norole.png" />
          </template>
        </a-empty>
      </div>
    </div>

    <a-modal
      :title="modalConfig.title"
      :visible="visible"
      :maskClosable="false"
      @ok="onSave"
      @cancel="handleCancel"
    >
      <a-form-model
        :labelCol="{ span: 6 }"
        :wrapperCol="{ span: 14 }"
        :rules="rules"
        ref="formRef"
        :model="formValues"
        :form="form"
      >
        <a-form-model-item
          label="企业名称"
          prop="enterpriseName"
          v-if="selectedKeys[0] === 0"
        >
          <a-input v-model="formValues.enterpriseName" placeholder="企业名称" />
        </a-form-model-item>
        <a-form-model-item label="部门名称" prop="departmentName" v-else>
          <a-input v-model="formValues.departmentName" placeholder="部门名称" />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-input v-model="formValues.remark" placeholder="请输入备注信息" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <StaffAssignmentsModal
      ref="staffAssignments"
      :existList="existList"
      :notExistList="notExistList"
      @getDataList="getDataList"
    />
  </div>
</template>
<script>
import StaffAssignmentsModal from "./StaffAssignmentsModal";
import {
  treeData,
  dataList,
  addDepartment,
  editDepartment,
  removeDepartment,
  notBindData,
  hasBindData,
  removeOutDepartment,
  //enterpriseInfo,
  editEnterprise,
} from "./service";
import scrollbarInit from "@/utils/perfectScrollBar";
import TreeModel from "tree-model";

let scrollbar = null;
export default {
  name: "",
  components: {
    StaffAssignmentsModal,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      currentDepartment: {},
      dataSource: [],
      enterprise: {}, //企业信息
      treeData: [],
      pagination: {
        current: 0,
        pageSize: 10,
        total: 0,
      },
      formValues: {},
      visible: false,
      modalConfig: {},
      modalRecord: {},
      selectedKeys: "",
      existData: [],
      existList: [],
      notExistList: [],
      treeRoot: null,
    };
  },
  mounted() {
    this.getTreeData();
  },
  computed: {
    getColumns() {
      const columns = [
        {
          title: "序号",
          dataIndex: "id",
          ellipsis: true,
          align: "center",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "用户名称",
          dataIndex: "nickName",
          ellipsis: true,
          align: "center",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "联系方式",
          dataIndex: "phone",
          ellipsis: true,
          align: "center",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "角色",
          dataIndex: "roleName",
          ellipsis: true,
          align: "center",
          customRender: (text) => {
            return text || "--";
          },
        },
      ];
      if (this.selectedKeys.length > 0 && this.selectedKeys[0] !== 0) {
        columns.push({
          title: "操作",
          dataIndex: "",
          scopedSlots: { customRender: "operation" },
          ellipsis: true,
          width: 100,
        });
      }
      return columns;
    },
    watch: {
      selectedKeys: function () {
        if (this.selectedKeys && this.selectedKeys.length > 0) {
          this.$nextTick(() => {
            this.cresteScrollBar();
          });
        }
      },
    },
    rules() {
      const tmp = {
        departmentName: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
        ],
      };
      return tmp;
    },
  },
  methods: {
    cresteScrollBar() {
      scrollbar = scrollbarInit("#tables");
      const dom = document.querySelector("#tables");
      dom.scrollTop = 0;
      scrollbar.update();
    },
    async getTreeData() {
      try {
        this.treeData = [];
        // const request = await enterpriseInfo.request();

        // if (request.bizCode === 1) {
        //   this.enterprise = request.data;
        // }

        const res = await treeData.request();

        if (res.bizCode === 1) {
          let temp = this.readNodes(res.data);
          // this.treeData = temp;
          console.log(temp);
          // let tree = []
          // this.treeData.push({
          //   key: this.enterprise.id,
          //   title: this.enterprise.enterpriseName,
          //   scopedSlots: {
          //     title: "title",
          //   },
          //   children: temp,
          //   ...this.enterprise,
          // });
          this.treeData = temp;
          const root = new TreeModel();
          let tree = root.parse({ id: -1, children: temp });
          this.treeRoot = tree;
          console.log("this.treeData", this.treeData);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onSearchTree(value) {
      try {
        this.treeData = [];
        let params = {
          departmentName: value,
        };
        const res = await treeData.request(params);

        if (res.bizCode === 1) {
          let temp = this.readNodes(res.data);
          // this.treeData = temp;
          this.treeData.push({
            key: this.enterprise.id,
            title: this.enterprise.enterpriseName,
            children: temp,
            ...this.enterprise,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    readNodes(nodes = []) {
      nodes.map((item) => {
        item.key = item.id;
        item.title = item.departmentName;
        item.scopedSlots = {
          title: "title",
        };
        if (item.children && item.children.length)
          this.readNodes(item.children);
      });
      return nodes;
    },
    async getDataList() {
      try {
        let params = {};

        if (this.selectedKeys[0] !== 0) {
          params = {
            departmentId: this.selectedKeys[0],
          };
        }

        const res = await dataList.request(params);

        if (res.bizCode === 1) {
          this.dataSource = res.data.items;
          const pagination = {
            current: res.data.pageNo + 1,
            pageSize: 10,
            total: res.data.totalCount,
          };
          this.pagination = pagination;
        }
      } catch (error) {
        console.log(error);
      }
    },
    onSearch() {},
    onSelect(selectedKeys, info) {
      console.log("onSelect", info);
      console.log("selectedKeys", selectedKeys);
      if (info.selected) {
        this.selectedKeys = selectedKeys;
        let currentDepartment = {
          ...info.selectedNodes[0].data.props,
        };

        let nodes = this.treeRoot.first(function (node) {
          return node.model.id === selectedKeys[0];
        });

        // console.log(nodes)
        if (nodes.parent && nodes.parent.model.id !== -1) {
          currentDepartment.parentName = nodes.parent.model.departmentName;
        }

        this.currentDepartment = currentDepartment;
        console.log(info.selectedNodes[0].data.props);
        this.getDataList();
      } else {
        this.selectedKeys = "";
      }
    },
    async removeOut(record) {
      try {
        let ids = [];
        ids.push(record.id);
        const params = {
          ids: ids,
        };

        const res = await removeOutDepartment.request(params);

        if (res.bizCode === 1) {
          this.$message.success("移出成功", 4);
          this.getDataList();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async remove() {
      try {
        const params = {
          id: this.currentDepartment.id,
        };

        const res = await removeDepartment.request(params);

        if (res.bizCode === 1) {
          this.$message.success("删除成功", 4);
          this.currentDepartment = {};
          this.getTreeData();
          this.selectedKeys = "";
        }
      } catch (error) {
        console.log(error);
      }
    },

    showDeleteModal({ type, record }) {
      let that = this;
      console.log(type, record);
      if (type === "remove") {
        this.$confirm({
          class: "delete-confirm-modal",
          title: "删除部门",
          content: "确定删除部门?",
          okText: "确定",
          okType: "primary",
          centered: true,
          width: 320,
          icon: () => (
            <a-icon
              type="info-circle"
              theme="twoTone"
              two-tone-color="#0F9F64"
            />
          ),
          onOk() {
            that.remove();
          },
          onCancel() {
            console.log("cancel");
          },
        });
      } else if (type === "removeOut") {
        this.$confirm({
          class: "delete-confirm-modal",
          title: "移出部门",
          content: "确定移出部门?",
          okText: "确定",
          okType: "primary",
          centered: true,
          width: 320,
          icon: () => (
            <a-icon
              type="info-circle"
              theme="twoTone"
              two-tone-color="#0F9F64"
            />
          ),
          onOk() {
            that.removeOut(record);
          },
          onCancel() {
            console.log("cancel");
          },
        });
      }
    },
    add() {
      this.visible = true;
      this.modalConfig = {
        type: "add",
        title: "添加部门",
      };
      if (this.selectedKeys[0] === 0 || this.selectedKeys.length === 0) {
        this.formValues = {};
      } else {
        if (this.currentDepartment.level === 1) {
          this.formValues = {
            parentId: this.currentDepartment.id,
          };
        } else if (this.currentDepartment.level === 2) {
          this.formValues = {
            parentId: this.currentDepartment.id,
            rootParentId: this.currentDepartment.parentId,
          };
        }
      }
      console.log("currentDepartment", this.currentDepartment);
      console.log("formValues", this.formValues);
    },
    edit() {
      this.visible = true;
      this.modalConfig = {
        type: "edit",
        title: "修改部门",
      };
      if (this.selectedKeys[0] === 0) {
        this.formValues = {
          id: this.enterprise.id,
          enterpriseName: this.enterprise.enterpriseName,
          remark: this.enterprise.remark,
        };
      } else {
        this.formValues = {
          id: this.currentDepartment.id,
          departmentName: this.currentDepartment.departmentName,
          remark: this.currentDepartment.remark,
        };
      }
    },
    onSave() {
      try {
        const formRef = this.$refs.formRef;
        formRef.validate((valid) => {
          if (valid) {
            let formValues = this.formValues;
            const params = {
              ...formValues,
            };
            let requestMethod = null;
            if (this.modalConfig.type === "add") {
              requestMethod = addDepartment;
            } else {
              if (this.selectedKeys[0] === 0) {
                requestMethod = editEnterprise;
              } else {
                requestMethod = editDepartment;
              }
            }

            requestMethod.request(params).then((result) => {
              if (result.bizCode === 1) {
                if (this.modalConfig.type === "add") {
                  this.$message.success("创建成功", 4);
                  this.handleCancel();
                } else {
                  this.$message.success("编辑成功", 4);
                  this.handleCancel();
                  this.currentDepartment = {
                    ...formValues,
                    lastUpdated: this.currentDepartment.lastUpdated,
                  };
                  this.getDataList();
                }
                this.getTreeData();
              } else this.$message.warning(result.bizRemind, 4);
            });
          }
        });
      } catch (err) {
        console.error(err);
      }
    },
    handleCancel() {
      this.visible = false;
      this.modalConfig = {};
      this.modalRecord = {};
      this.form.resetFields();
    },
    refreshTable() {
      this.getDataList({
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize,
      });
    },
    async openStaffAssignments(record) {
      try {
        let existList = [];
        let notExistList = [];
        const param = {
          departmentId: this.selectedKeys[0],
        };

        const request = await hasBindData.request(param);

        if (request.bizCode === 1) {
          this.existData = request.data.items;
          request.data.items.map((item) => {
            existList.push(item.id);
          });
        }

        const params = {
          departmentId: this.selectedKeys[0],
        };

        const res = await notBindData.request(params);

        if (res.bizCode === 1) {
          res.data.map((item) => {
            let name = "";
            if (item.departmentName) {
              name = item.nickName + "（" + item.departmentName + "）";
            } else {
              name = item.nickName;
            }
            notExistList.push({
              key: item.id,
              title: name,
              department: item,
            });
          });
          this.existData.map((item) => {
            notExistList.push({
              key: item.id,
              title: item.nickName,
              department: item,
            });
          });
        }
        this.existList = existList;
        this.notExistList = notExistList;
        console.log("existList", existList);
        console.log("notExistList", notExistList);
        this.$refs.staffAssignments.openStaffAssignmentsModal(record);
      } catch (error) {
        console.log(error);
      }
    },
    showRemoveConfirm() {
      let that = this;
      this.$confirm({
        class: "delete-confirm-modal",
        title: "您确定需要删除部门吗？",
        content: "该部门删除后不可恢复！",
        okText: "删除",
        okType: "primary",
        centered: true,
        width: 320,
        icon: () => (
          <a-icon type="info-circle" theme="twoTone" two-tone-color="#0F9F64" />
        ),
        onOk() {
          that.remove();
        },
        onCancel() {
          console.log("cancel");
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../../../styles/common.less");
@import "../../../utils/convertPxToDesighViewport/convertPxToDesighViewport";
//.convertPxToDesighVH(20)[] .convertPxToDesighVW(20)[]

.wrap {
  // min-height: 100%;
  height: @full-page-container-height;
  //height: 100%;
  display: flex;
  .left {
    width: .convertPxToDesighVW(220) [];
    height: @full-page-container-height;
    background: #192430;
    border: .convertPxToDesighVH(2) [] solid #293646;
    opacity: 1;
    border-radius: .convertPxToDesighVH(10) [];
    margin-right: .convertPxToDesighVW(24) [];
    display: flex;
    flex-direction: column;
    padding: .convertPxToDesighVH(20) [];
    .tree-wrap {
      flex: 1;
      //overflow: hidden;
      .tree {
        //overflow: auto;
        height: .convertPxToDesighVH(660) [];
      }
    }
  }
  .right {
    width: calc(100% - .convertPxToDesighVW(220) []);
    border-radius: .convertPxToDesighVH(10) [];
    height: @full-page-container-height;
    .no-empty {
      background: #192430;
      border: .convertPxToDesighVH(2) [] solid #293646;
      opacity: 1;
      border-radius: .convertPxToDesighVH(10) [];
      height: 100%;
    }
    .empty-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .header-wrap {
      padding: .convertPxToDesighVH(24) [];
      background: #192430;
      border: .convertPxToDesighVH(2) [] solid #293646;
      opacity: 1;
      border-radius: .convertPxToDesighVH(10) [];
      height: .convertPxToDesighVH(200) [];
      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        > .line-title {
          display: flex;
          align-items: center;
          .line {
            width: .convertPxToDesighVW(4) [];
            height: .convertPxToDesighVH(16) [];
            background: #0f9f64;
            opacity: 1;
            border-radius: .convertPxToDesighVH(4) [];
            margin-right: .convertPxToDesighVW(8) [];
          }
          .title {
            font-size: .convertPxToDesighVH(16) [];
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #e2f2ff;
          }
        }
        .btn-wrap {
          display: flex;
        }
      }
      .info {
        margin-top: .convertPxToDesighVH(20) [];
        padding: .convertPxToDesighVH(24) [];
        background: #091121;
        opacity: 1;
        border-radius: .convertPxToDesighVH(20) [];
        .info-item {
          display: flex;
          align-items: center;
          font-size: .convertPxToDesighVH(14) [];
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #909ca6;
          .value {
            margin-left: .convertPxToDesighVW(10) [];
            margin-right: .convertPxToDesighVW(10) [];
            text-align: left;
          }
          .label {
            width: .convertPxToDesighVW(120) [];
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }
    .table-wrap {
      margin-top: .convertPxToDesighVH(24) [];
      background: #192430;
      border: .convertPxToDesighVH(2) [] solid #293646;
      opacity: 1;
      border-radius: .convertPxToDesighVH(10) [];
      height: calc(100% - .convertPxToDesighVH(224) []);
      .table-title {
        padding: .convertPxToDesighVH(24) [];
        display: flex;
        align-items: center;
        justify-content: space-between;
        > .line-title {
          display: flex;
          align-items: center;
          .line {
            width: .convertPxToDesighVW(4) [];
            height: .convertPxToDesighVH(16) [];
            background: #0f9f64;
            opacity: 1;
            border-radius: .convertPxToDesighVH(4) [];
            margin-right: .convertPxToDesighVW(8) [];
          }
          .title {
            font-size: .convertPxToDesighVH(16) [];
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #e2f2ff;
          }
        }
      }
      .table {
        padding: 0px .convertPxToDesighVW(24) [];
        height: calc(100% - .convertPxToDesighVH(100) []);
      }
    }
  }
}
#tables {
  height: calc(100% - .convertPxToDesighVH(100) []);
  position: relative;
  overflow: hidden;
}
</style>
